import axios from "axios";

export const mentorQuery = async () => {
  console.log("running mentor query");
  return await axios.get(
    `https://4osc9lyuza.execute-api.ap-south-1.amazonaws.com/mentors/info`
  );
};

export const submitStudentQuery = async (form) => {
  const options = {};
  return await axios.post(
    `https://4osc9lyuza.execute-api.ap-south-1.amazonaws.com/mentors/query`,
    form,
    options
  );
};
